export default "__VITE_ASSET__5ef981b5__"